import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import msgToask from '../utils/msgToask';
import utilsRecervas from '../utils/utilsRecervas';
import Header from './Header'
import MsgAlertas from './utils/MsgAlertas';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

const restricciones_desactivadas = process.env.REACT_APP_RESTRICCIONES_DESACTIVADAS === "true";

function DatoAdicional(props) {
    const { regional } = props;
    const navigate = useNavigate()
    const [message, setMessage] = useState('');
    const [alerta, setAlerta] = useState(false);
    const [horaPedido, setHoraPedido] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [cliente, setCliente] = useState('');
    const [pedidoNormal, setPedidoNormal] = useState(true);
    const [mostrarAdvertencia, setMostrarAdvertencia] = useState(false);
    const [mensajeAdvertencia, setMensajeAdvertencia] = useState("");
    const [estadoRecogera, setEstadoRecogera] = useState("Local");
    const [pisoSeleccionado, setPisoSeleccionado] = useState(1);
    const [numeroDePisos, setNumeroDePisos] = useState(1);
    const [condicionPisos, setCondicionPisos] = useState(true);
    const [condicionMensajeParaLlevar, setCondicionMensajeParaLlevar] = useState(false);

    const nombresPisos = ["Planta baja", "Planta alta", "Segundo piso", "Tercer piso", "Cuarto piso"];

    function validarOpenSucursal(suc, hora) {

        let pedidoConRuta = localStorage.getItem('pedidoConRuta');
        let condicion = pedidoConRuta == "true";

        if (condicion) {
            let regionalActualizada = localStorage.getItem('ciudad')
            var infor = utilsRecervas.getHorarioSucursalRegional(regionalActualizada, 9);
        } else {
            var infor = utilsRecervas.getHorarioSucursalRegional(regional, 9);
        }

        var hro = 0, hrc = 0
        if (infor[infor.indexOf(3)] != 0) {
            hro = infor[4];
            hrc = infor[5];
        }
        var info = utilsRecervas.getHorarioSucursal(9)
        var horaIni = info[info.indexOf(suc) + 1];
        var horaFin = info[info.indexOf(suc) + 2];
        var dayminutes = (parseInt(hora[0]) * 60) + parseInt(hora[1]);
        if ((dayminutes >= horaIni && (hro == 0 || dayminutes >= hro)) && (dayminutes < horaFin && (hrc == 0 || dayminutes < hrc))) {
            return true;
        } else {
            console.log("hora no valida");
            let scu = localStorage.getItem('filtroSucursal')
            var sucursalname = utilsRecervas.getNombreSucursal(scu);
            var info = utilsRecervas.getHorarioSucursal(scu)
            var horaIni = Math.trunc(info[info.indexOf(scu) + 1] / 60);
            var horaFin = Math.trunc(info[info.indexOf(scu) + 2] / 60);
            setMessage("El pedido para la sucursal " + sucursalname + " es permitido entre " + horaIni + ' - ' + horaFin + ' Horas.')
            return false;
        }
    }

    function validarHora(hora, condicionRuta) {
        var horas = hora.split(':');
        var day = new Date()
        if (parseInt(horas[0]) >= day.getHours()) {
            if ((parseInt(horas[0]) * 60) + parseInt(horas[1]) >= (day.getHours() * 60) + day.getMinutes() + 20) {
                return validarOpenSucursal(localStorage.getItem('filtroSucursal'), hora.split(':'))
            } else {
                setMensajeAdvertencia("Su pedido podria tardar 20-30 minutos adicionales a su hora de pedido seleccionada, dependiendo de la disponibilidad del pollo o pipocas.");
                return validarOpenSucursal(localStorage.getItem('filtroSucursal'), hora.split(':'))
                //else{
                //setMessage("Hora incorrecta, por lo menos tiene que tener 30 minutos de diferencia de la hora actual, gracias !");
                //return false
                //}
            }
        } else {
            setMessage("Ya son las " + day.getHours() + " Hrs, selecciones la hora igual o mayor gracias.");
            return false;
        }
    }

    function siquientePaso() {

        let pedidoConRuta = localStorage.getItem('pedidoConRuta');
        let condicionRuta = pedidoConRuta == "true";

        if (condicionRuta || cliente !== '') {

            if (restricciones_desactivadas || (condicionRuta || validarHora(horaPedido, condicionRuta))) {

                let estadoDespacho = estadoRecogera === 'Local' ? 'A' : 'L';

                if (condicionRuta) {
                    let aux = new Date();
                    let hora = aux.getHours() < 10 ? '0'.concat(aux.getHours()) : aux.getHours();
                    let minutes = aux.getMinutes() < 10 ? '0'.concat(aux.getMinutes()) : aux.getMinutes();
                    localStorage.setItem('infUser', JSON.stringify({ 'recogera': "CLIENTE", observaciones, 'para_hora': hora + ':' + minutes, estadoDespacho, 'id_despacho': pisoSeleccionado }));

                } else {
                    localStorage.setItem('infUser', JSON.stringify({ 'recogera': cliente, observaciones, 'para_hora': horaPedido, estadoDespacho, 'id_despacho': pisoSeleccionado }));
                }

                let horas = horaPedido.split(':');
                let day = new Date()

                //console.log(localStorage.getItem('infUser'))
                if (!condicionRuta && verificarSiExisteAdvertencia() && !((parseInt(horas[0]) * 60) + parseInt(horas[1]) >= (day.getHours() * 60) + day.getMinutes() + 20)) {
                    setMostrarAdvertencia(true);
                } else {
                    navigate("/reservar", { replace: true });
                }

            } else {
                setAlerta(true);
            }
        } else {
            setMessage('Ingrese el nombre de la persona que recogerá el pedido.');
            setAlerta(true);
        }
    }
    function verificarSiExisteAdvertencia() {
        var cesta = JSON.parse(localStorage.getItem('carrito'));
        const idsPollosYPipocas = [1, 2, 3, 4, 5, 6, 28, 29, 30];
        const existe = cesta[0].detalle.some(pedido => idsPollosYPipocas.includes(pedido.idMenu));

        return existe;
    }

    function cambiarEstadoRecogera(e) {
        if (e.target.value == "Local") {
            setCondicionPisos(true);
            setCondicionMensajeParaLlevar(false);
        } else {
            setPisoSeleccionado(1);
            setCondicionPisos(false);
            setCondicionMensajeParaLlevar(true);
        }
        setEstadoRecogera(e.target.value);
    }

    function cambiarPiso(e) {
        setPisoSeleccionado(e.target.value);
    }

    useEffect(() => {

        var aux = new Date()
        var hora = aux.getHours() < 10 ? '0'.concat(aux.getHours()) : aux.getHours();
        var minutes = aux.getMinutes() < 10 ? '0'.concat(aux.getMinutes()) : aux.getMinutes();

        let pedidoConRuta = localStorage.getItem('pedidoConRuta');
        let condicion = pedidoConRuta == "true";
        console.log(condicion)

        let idSucursal = localStorage.getItem('filtroSucursal');

        let sucursales = JSON.parse(localStorage.getItem('sucursales'));

        let sucursalActual = sucursales.find(sucursal => sucursal.ID_SUCURSAL == idSucursal)
        if (sucursalActual) {
            setNumeroDePisos(sucursalActual.NUMERO_DE_PISOS)
        }

        let pisoSeleccionadoAux = localStorage.getItem("pisoSeleccionado");

        if (pisoSeleccionadoAux && sucursalActual.NUMERO_DE_PISOS > 1 && condicion) {
            setPisoSeleccionado(pisoSeleccionadoAux);
        }

        if (condicion) {
            setPedidoNormal(false);
        }

        setHoraPedido(hora + ':' + minutes);
        var datosU = JSON.parse(localStorage.getItem('infUser'));
        if (datosU !== null && datosU !== undefined && !condicion) {
            setCliente(datosU.recogera);
            setObservaciones(datosU.observaciones);
            setHoraPedido(datosU.para_hora);
        }
    }, [])
    return (
        <div className='fondoColor w-100 vh-100'>
            <Header pagina={5} title={"Mi Pedido"} callback={() => { navigate("/miPedido", { replace: true }); }} />
            <div className='container-fluid col-sm-12 col-md-6 col-xl-4'>

                {pedidoNormal && (
                    <>
                        <div className='text-center textInicio mt-4'>
                            Nombre de quien recogerá
                        </div>
                        <input
                            type="text"
                            value={cliente}
                            onChange={(e) => setCliente(e.target.value)}
                            className="form-control textInfo my-2 borderEdit"
                            maxLength={30}
                            placeholder='Nombre cliente ...'
                        />
                    </>
                )}

                <div className='mt-3'>
                    <textarea type="text"
                        value={observaciones}
                        className="form-control textInfo mb-2 borderEdit"
                        placeholder='Ingrese alguna nota para el pedido (opcional)'
                        onChange={(e) => setObservaciones(e.target.value.toUpperCase())}
                        style={{ height: '90px' }} />
                </div>

                <div className='text-center textInicio mt-3'>
                    Tipo de pedido
                </div>

                <Form className='my-2 text-center'>
                    <div className="d-flex justify-content-center gap-4">
                         {localStorage.getItem('filtroSucursal') !== '29' && (
                            <Form.Check
                                    type="radio"
                                    label="Pedido para consumir en local"
                                    value="Local"
                                    checked={estadoRecogera === 'Local'}
                                    onChange={cambiarEstadoRecogera}
                                    className='estilo_boton_radio'
                                />
                            )}

                        <Form.Check
                            type="radio"
                            label="Pedido para llevar"
                            value="Llevar"
                            checked={estadoRecogera === 'Llevar'}
                            onChange={cambiarEstadoRecogera}
                            className='estilo_boton_radio'
                        />

                    </div>
                </Form>

                {condicionMensajeParaLlevar && (
                    <>
                        <div className='container my-3 contenedor_mensaje' >
                            <div className='text-center'>
                                El pedido para llevar deberá recogerse en planta baja.
                            </div>
                        </div>
                    </>
                )}

                {condicionPisos && (numeroDePisos > 1) && (
                    <>
                        <div className='container my-3'>
                            <div className='text-center mb-2 textInicio'>
                                Escoja el piso para su pedido
                            </div>

                            <Form.Select value={pisoSeleccionado}
                                style={{ width: '130px' }}
                                aria-label="Default select example"
                                onChange={cambiarPiso}
                                className="d-block mx-auto"
                            >
                                {Array.from({ length: numeroDePisos }, (_, i) => (
                                    <option key={i} value={i + 1}>
                                        {nombresPisos[i] || `Piso ${i}`}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </>
                )}

                {pedidoNormal && (
                    <>
                        <div className='text-center textInicio mt-3'>
                            ¿Para que hora quiere su Pedido?
                        </div>
                        <input type="time" style={{ width: '120px', alignItems: 'right' }}
                            value={horaPedido}
                            className="form-control textInfo text-center mx-auto"
                            id='hora'
                            onChange={(e) => { setHoraPedido(e.target.value) }} />
                        <div className='text-center my-auto textCard'>
                            Horas
                        </div>
                    </>
                )}

            </div>
            <div className='container-fluid col-sm-12 col-md-6 col-xl-4 fixed-bottom mb-1'>
                <div className='container-fluid rounded-pill text-center m-0 p-0'>
                    <button className='btn botonNaranja rounded-pill text-white w-100'
                        onClick={() => siquientePaso()}>
                        Siguiente <i className="fa-solid fa-circle-arrow-right"></i>
                    </button>
                </div>
            </div>
            <MsgAlertas msg={message} show={alerta} callback={() => setAlerta(false)} />

            <Modal show={mostrarAdvertencia} contentClassName="bg-transparent "
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header bsPrefix="modal-header m-0 p-0">
                    <div className='verPedidoButon w-100 text-center my-auto py-1'
                        style={{ borderTopRightRadius: '10px', borderTopLeftRadius: '10px' }}>
                        <div className='text-white textTitle'><i className="fa-solid fa-circle-exclamation"></i> NOTIFICACIÓN</div>
                    </div>
                </Modal.Header>
                <Modal.Body bsPrefix="modal-body m-0 p-0 bg-light">
                    <div className='container-fluid py-4'>
                        <p className='textInfo text-center mb-1'><i className="fa-solid fa-triangle-exclamation fa-2xl fa-fade"></i> {mensajeAdvertencia}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer bsPrefix="modal-footer text-center m-0 p-0 mx-auto bg-light w-100">
                    <button className="btn botonNaranja text-light rounded-pill" onClick={() => { navigate("/reservar", { replace: true }); }}>
                        Aceptar
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DatoAdicional
